/* eslint-disable camelcase */
import { Fonts } from './fonts'
import { probeAdblock } from './probe-adblock'
import { probeIncognito } from './probe-incognito'
import { probeWebGL } from './probe-webgl'

export type BrowserData = {
  screen_width: number
  screen_height: number
  screen_depth: number
  language: string
  platform: string
  timezone_offset: number
  software: number
  block: number
  incognito: boolean | null
  webgl_vendor: string | null
  webgl_renderer: string | null
}

export const getBrowserData = async () => {
  const { screen, navigator } = window

  const webgl = probeWebGL()
  const browser: BrowserData = {
    screen_width: screen.width,
    screen_height: screen.height,
    screen_depth: screen.colorDepth,
    language: navigator.language,
    platform: navigator.platform,
    timezone_offset: new Date().getTimezoneOffset(),
    software: getBrowserSoftware(),
    block: await getBrowserBlock(),
    incognito: await probeIncognito(),
    webgl_vendor: webgl.vendor,
    webgl_renderer: webgl.renderer,
  }

  return browser
}

const getBrowserBlock = async () => {
  let block = 0

  // facebook, flash, adblock
  const items = [false, false, await probeAdblock()]

  for (let i = 0; i < items.length; i++) {
    if (items[i]) {
      block |= 1 << i
    }
  }

  return block
}

const hasFont = (font: string, fonts: string[]): boolean =>
  fonts.indexOf(font) !== -1

// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/mimeTypes
const hasEnabledPlugin = (mimeType: string) => {
  if (mimeType in navigator.mimeTypes) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { enabledPlugin } = navigator.mimeTypes[mimeType]

    return enabledPlugin
  }

  return false
}

const getBrowserSoftware = () => {
  let software = 0
  const items: boolean[] = []

  const fonts = Fonts.detect()

  items.push(hasFont('Bell MT', fonts)) // MS Office
  items.push(hasFont('Liberation Sans', fonts)) // LibreOffice
  items.push(
    hasFont('DejaVu Sans', fonts) && !hasFont('Liberation Sans', fonts)
  ) // OpenOffice
  items.push(hasFont('Adobe Arabic', fonts)) // Adobe Photoshop CS6
  items.push(hasEnabledPlugin('application/x-adobeaamdetect')) // Adobe CC
  items.push(hasEnabledPlugin('application/x-shockwave-flash')) // Adobe Flash Player
  items.push(hasEnabledPlugin('application/x-picasa-detect')) // Google Picasa
  items.push(hasEnabledPlugin('application/googletalk')) // Google Talk
  items.push(hasEnabledPlugin('application/geplugin')) // Google Earth
  items.push(hasEnabledPlugin('application/itunes-plugin')) // Apple iTunes
  items.push(hasEnabledPlugin('application/x-skype')) // Skype
  items.push(hasEnabledPlugin('application/x-vnd-lastpass')) // LastPass
  items.push(hasEnabledPlugin('application/x-silverlight')) // Silverlight
  items.push(hasEnabledPlugin('application/x-java-applet')) // Java

  for (let i = 0; i < items.length; i++) {
    if (items[i]) {
      software |= 1 << i
    }
  }

  return software
}
